import { render, staticRenderFns, recyclableRender, components } from "./uni-td.vue?vue&type=template&id=321f8e79&"
var renderjs
import script from "./uni-td.vue?vue&type=script&lang=js&"
export * from "./uni-td.vue?vue&type=script&lang=js&"
import style0 from "./uni-td.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-table/components/uni-td/uni-td.vue"
export default component.exports